import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: false,
    name: 'huf'
})
export class HufPipe implements PipeTransform {
    transform(value: number, supressPlusSign: boolean = true, suppressDecimals: boolean = false): any {
        if (!value) {
            return "0";
        }
        let thousendSeparator: string;
        let decimalSeparator: string;
        let numValue: number = value;
        if (suppressDecimals) {
            numValue = Math.round(numValue);
        }
        thousendSeparator = ".";
        decimalSeparator = ",";

        if (numValue === undefined || numValue === null) {
            return `${'?'}`;
        }

        const negativeSign: string = numValue.toString().substr(0, 1) === "-" ? "-" : "";
        const positiveSign: string = numValue > 0 && !supressPlusSign ? "+" : "";
        let remainder: number;

        if (numValue == 0) {
            if (suppressDecimals) {
                return "0";
            } else {
                return "0" + decimalSeparator + "00";
            }
        }

        const arr = Math.abs(numValue - (parseInt(numValue.toString()))).toString().split('.');
        if (arr.length === 2) {
            remainder = parseInt(arr[1]);
        }
        else {
            remainder = 0;
        }

        let currencyAsString: string = Math.abs(parseInt(numValue.toString())).toString();
        let len = currencyAsString.length;
        var strRet = '';
        var fraction = '';

        var j = 0;
        for (var i = len; i > -1; i--) {
            if ((j % 3 === 0) && (j !== 0)) {
                if (i !== 0) {
                    strRet = thousendSeparator + currencyAsString.substr(i, 1) + strRet;
                }
                else {
                    strRet = currencyAsString.substr(i, 1) + strRet;
                }
            }
            else {
                strRet = currencyAsString.substr(i, 1) + strRet;
            }
            j++;

            if (!suppressDecimals) {
                switch (remainder.toString().length) {
                    case 0:
                        fraction = "00";
                        break;
                    case 1:
                        fraction = remainder.toString() + "0";
                        break;
                    default:
                        fraction = remainder.toString().substr(0, 2)
                        break;
                }
            } else {
                fraction = "";
                decimalSeparator = "";
            }
        }

        if (numValue === 0) {
            return strRet + decimalSeparator + fraction;
        }

        if (numValue < 0) {
            return negativeSign + strRet + decimalSeparator + fraction;
        }
        else {
            return positiveSign + strRet + decimalSeparator + fraction
        }
    }
}